import { render, staticRenderFns } from "./newUploadFiles.vue?vue&type=template&id=0cc641b2&scoped=true&"
import script from "./newUploadFiles.vue?vue&type=script&lang=js&"
export * from "./newUploadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc641b2",
  null
  
)

export default component.exports